import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const vehicleBaseEndpoint = ENDPOINTS.VEHICLES;

// Package Type API
export const vehicleApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["vehicles"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getVehicles: builder.query({
        query: (payload) => `${vehicleBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "vehicles" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addVehicle: builder.mutation({
        query: (requestData) => ({
          url: `${vehicleBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "vehicles" }],
      }),
      updateVehicle: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${vehicleBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "vehicles" }],
      }),
      deleteVehicle: builder.mutation({
        query: (id) => ({
          url: `${vehicleBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "vehicles" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
    useGetVehiclesQuery,
    useAddVehicleMutation,
    useUpdateVehicleMutation,
    useDeleteVehicleMutation,
} = vehicleApi;
